export const toggleLanguage = ['ES', 'CAT']
